import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useApp } from "@/context/AppContext";

export default function VerifyEmail() {
  const { t, verifyEmail } = useApp();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [state, setState] = useState("verifying");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("failed"); return; }
    verifyEmail(token).then(() => { setState("done"); setTimeout(() => { const nx = localStorage.getItem("gg_next"); localStorage.removeItem("gg_next"); nav(nx || "/"); }, 1800); }).catch(() => setState("failed"));
  }, []); // eslint-disable-line

  return (
    <div className="max-w-md mx-auto px-4 py-16 text-center">
      <div className="gg-card p-8" data-testid="verify-email-card">
        <div className="eyebrow mb-3">{t("email")}</div>
        <h1 className="font-display uppercase text-3xl tracking-tighter" data-testid={`verify-state-${state}`}>
          {state === "verifying" ? t("verifying") : state === "done" ? t("verified") : t("verifyFailed")}
        </h1>
        {state === "failed" && <Link to="/auth" className="gg-btn mt-6 inline-flex" data-testid="verify-back-login">{t("backToLogin")}</Link>}
      </div>
    </div>
  );
}
